<app-header-carousel></app-header-carousel>
<app-image-slider-carousel></app-image-slider-carousel>
<app-milestones></app-milestones>
<app-technology-services></app-technology-services>
<app-footer></app-footer>
